import { useMemo } from 'react';
import type { ResultRow } from '../lib/result-detail';
import { resultTableColumnConfig } from '../config/resultTableColumnConfig';
import {
  INDEXER_AG_GRID_FILL_HEIGHT,
  IndexerAgGrid,
} from './IndexerAgGrid';
import { IndexerIcon } from './IndexerIcon';

export type { ResultRow };

export function ResultTable({
  rows,
  fillHeight = false,
}: {
  rows: ResultRow[];
  /** Stretch grid to remaining drawer/modal height. */
  fillHeight?: boolean;
}) {
  const columns = useMemo(() => resultTableColumnConfig(), []);
  const otherOptions = useMemo(
    () => ({
      getRowId: (params: { data: ResultRow }) =>
        params.data.id ?? params.data.url,
      getRowHeight: (params: { data?: ResultRow }) =>
        params.data?.hints?.length ? 56 : 40,
      animateRows: false,
    }),
    [],
  );

  if (rows.length === 0) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center gap-2 text-center text-secondary py-5">
        <IndexerIcon name="table" />
        <p className="mb-0">هنوز نتیجه‌ای ثبت نشده است.</p>
      </div>
    );
  }

  const grid = (
    <IndexerAgGrid
      tableName="indexer_result_table"
      columns={columns}
      data={rows}
      height={fillHeight ? INDEXER_AG_GRID_FILL_HEIGHT : undefined}
      otherOptions={otherOptions}
    />
  );

  if (!fillHeight) return <div className="if-result-grid">{grid}</div>;

  return (
    <div className="indexer-fill-grid if-result-grid">
      <div className="indexer-fill-grid-body">{grid}</div>
    </div>
  );
}
